import React from 'react';
import { useAuth } from '../utils/AuthContext/AuthContext';  // Ensure the path is correct
import { useFormContext } from "../utils/FormContext.jsx"
import config from '../utils/config.js'; // Ensure the path is correct
import AISVG from '../assets/AI.jsx';

function HelpButton({ onClick }) {
    const { token, user } = useAuth(); // Use user and token from context
    const { formData, formId } = useFormContext(); // Use handleSave from context

return (
  <div>
    <button 
        className='text-shi-green w-auto md:w-[120px] h-[30px] pr-[2px] md:px-2 py-[1px] text-[14px] md:text-sm rounded-md flex items-center border font-light border-slate-700 hover:bg-slate-200 hover:text-shi-deep-purple'
        onClick={onClick}
    >
        <div className='inline-flex justify-between w-full items-center pr-1'>
            <AISVG width={22} height={22} />
            Ask Pepper
        </div>
    </button>
  </div>
);
}

export default HelpButton;